import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import HomeComponent from '@/components/Home'
import LoginComponent from '@/components/Login'
import StoresComponent from '@/components/Stores'
import SaleComponent from '@/components/sale/Sale'
import OrderComponent from '@/components/order/Order'
import OrderPaymentComponent from '@/components/order/Payment'
import OrderFulfillComponent from '@/components/order/Fulfill'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeComponent,
    meta: {
      requiresLogin: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginComponent,
    meta: {
      requiresGuest: true,
      doesNotRequireApiKey: true,
      title: 'Login'
    }
  },
  {
    path: '/stores',
    name: 'stores',
    component: StoresComponent,
    meta: {
      requiresLogin: true,
      doesNotRequireApiKey: true,
      title: 'Select a Store'
    }
  },
  {
    path: '/sale',
    name: 'sale',
    component: SaleComponent,
    meta: {
      requiresLogin: true,
      title: 'Make a Sale'
    }
  },
  {
    path: '/order/:order_id',
    name: 'order.view',
    component: OrderComponent,
    props: true,
    meta: {
      requiresLogin: true,
      title: 'View Order'
    }
  },
  {
    path: '/order/:order_id/payment',
    name: 'order.payment',
    component: OrderPaymentComponent,
    props: true,
    meta: {
      requiresLogin: true,
      title: 'Make a Payment'
    }
  },
  {
    path: '/fulfill',
    name: 'fulfill',
    component: OrderFulfillComponent,
    meta: {
      requiresLogin: true,
      title: 'Fulfill Orders'
    }
  }
]

const router = new Router({
  routes: routes,
  linkActiveClass: 'active',
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresLogin) && !store.getters.isAuthenticated) {
    next('login')
  } else if (to.matched.some(record => !record.meta.doesNotRequireApiKey) && !store.getters.hasApiKey) {
    next('stores')
  } else if (to.matched.some(record => record.meta.requiresGuest) && store.getters.isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js